import { ChangeDetectionStrategy, Component, EventEmitter, input, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslocoModule } from '@jsverse/transloco';
import { CheckboxComponent } from 'shared/ui-common';

import { GuidelineActionDto, GuidelineActionSignificance } from '@treetop/shared/model';

@Component({
  standalone: true,
  imports: [TranslocoModule, FormsModule, MatFormFieldModule, CheckboxComponent],
  selector: 'sidebar-significance-preference',
  templateUrl: './significance-preference.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./significance-preference.component.scss'],
})
export class SignificancePreferenceComponent {
  @Input() public significance: GuidelineActionSignificance;
  @Input() public preferredOptionOrder: number;

  protected component = input.required<GuidelineActionDto>();

  @Input() public hidePreference: boolean;

  @Output() public significancePreferenceChanged = new EventEmitter<
    Partial<{ significance: GuidelineActionSignificance; preferredOptionOrder: number }>
  >();

  public onOptionalChanged(isChecked: boolean) {
    this.significancePreferenceChanged.emit({
      significance: isChecked ? GuidelineActionSignificance.Optional : GuidelineActionSignificance.Required,
    });
  }

  public onPreferredOptionChanged(isChecked: boolean) {
    this.significancePreferenceChanged.emit({
      preferredOptionOrder: isChecked ? 1 : null,
    });
  }
}
